import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";
import { Plus, Trash2 } from "lucide-react";

const CrmTerritoryPanel = () => {
  const [territories, setTerritories] = useState([]);
  const [saving, setSaving] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    fetch(`${url}/leads/territories`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => setTerritories(res?.territories || []))
      .catch(() => setTerritories([]));
  }, [url, token]);

  const save = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${url}/leads/territories`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ territories }),
      });
      if (!res.ok) throw new Error("Save failed");
      const data = await res.json();
      setTerritories(data.territories || territories);
      toast.success("Territories saved");
    } catch {
      toast.error("Could not save territories");
    } finally {
      setSaving(false);
    }
  };

  const addTerritory = () => {
    setTerritories((prev) => [
      ...prev,
      {
        id: `territory_${Date.now()}`,
        name: "New territory",
        pincodePrefixes: [],
        staff_id: "",
        staff_name: "",
        city: "",
      },
    ]);
  };

  const update = (index, field, value) => {
    setTerritories((prev) =>
      prev.map((t, i) => {
        if (i !== index) return t;
        if (field === "pincodePrefixes") {
          return {
            ...t,
            pincodePrefixes: String(value)
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean),
          };
        }
        return { ...t, [field]: value };
      })
    );
  };

  return (
    <div className="crm-territory">
      <div className="crm-integrations__head">
        <strong>Territory routing</strong>
        <button type="button" onClick={addTerritory}>
          <Plus size={14} /> Add territory
        </button>
      </div>
      <p className="crm-insights__muted">
        Auto-assign new leads by pincode prefix or city when no rep is already assigned.
      </p>

      {territories.map((t, index) => (
        <div key={t.id || index} className="crm-workflow__card">
          <div className="crm-platform__stage-row">
            <input
              className="crm-platform__input"
              placeholder="Territory name"
              value={t.name}
              onChange={(e) => update(index, "name", e.target.value)}
            />
            <button type="button" onClick={() => setTerritories((p) => p.filter((_, i) => i !== index))}>
              <Trash2 size={14} />
            </button>
          </div>
          <input
            className="crm-platform__input"
            placeholder="Pincode prefixes (comma-separated, e.g. 400,401)"
            value={(t.pincodePrefixes || []).join(", ")}
            onChange={(e) => update(index, "pincodePrefixes", e.target.value)}
          />
          <input
            className="crm-platform__input"
            placeholder="City contains (optional)"
            value={t.city || ""}
            onChange={(e) => update(index, "city", e.target.value)}
          />
          <input
            className="crm-platform__input"
            placeholder="Staff ID"
            value={t.staff_id || ""}
            onChange={(e) => update(index, "staff_id", e.target.value)}
          />
          <input
            className="crm-platform__input"
            placeholder="Staff name"
            value={t.staff_name || ""}
            onChange={(e) => update(index, "staff_name", e.target.value)}
          />
        </div>
      ))}

      <button type="button" className="crm-platform__save" onClick={save} disabled={saving}>
        {saving ? "Saving…" : "Save territories"}
      </button>
    </div>
  );
};

export default CrmTerritoryPanel;
